import Button from '@material-ui/core/Button';
import InfoDialog, {InfoDialogProps, InfoDialogVariants} from 'cl-dialogs/InfoDialog';
import * as React from 'react';
import {useSelector} from 'react-redux';
import {StoreState} from '../App/initialStore';
import * as _ from 'lodash';
export interface WrongPlanDialogProps extends InfoDialogProps {
  selectedPlan: number;
  onContinueToPlan(planId: number): void;
  onTalkToUs(activeListingsCount: number): void;
}
const WrongPlanDialog: React.FunctionComponent<WrongPlanDialogProps> = ({
  onContinueToPlan,
  selectedPlan,
  onClose,
  onTalkToUs,
  ...props
}) => {
  const {planActiveListings, activeListingsCount, planAccountsLimit, connectedAccounts, recommendedPlan} = useSelector(
    ({user: {plans, activeListingsCount}, accountPage: {accounts}}: StoreState) => {
      const connectedAccounts = _.size(accounts);
      const plan = _.find(plans, {id: selectedPlan});
      return {
        planActiveListings: plan.activeListingsLimit,
        planAccountsLimit: plan.eBayAccountsLimit,
        activeListingsCount,
        connectedAccounts,
        recommendedPlan: _.minBy(
          _.filter(
            plans,
            ({eBayAccountsLimit, activeListingsLimit}) =>
              eBayAccountsLimit >= connectedAccounts && activeListingsLimit >= activeListingsCount
          ),
          ({price}) => Number(price)
        ),
      };
    }
  );
  return (
    <InfoDialog
      title="Oops.. Your account is over this plan's limit"
      variant={InfoDialogVariants.AreYouSure}
      instructionText={{
        before: 'To apply this plan please resolve the following:',
        after: recommendedPlan
          ? `Our '${recommendedPlan.name}' plan for up to ${Intl.NumberFormat().format(
              recommendedPlan.activeListingsLimit
            )} listings and ${recommendedPlan.eBayAccountsLimit} connected accounts will better fit your account.`
          : 'Or contact us about a plan that suites you',
      }}
      {...props}
      message={
        <>
          {connectedAccounts > planAccountsLimit
            ? `You have ${connectedAccounts} accounts connected while your new plan allows only ${planAccountsLimit}`
            : null}
          {connectedAccounts > planAccountsLimit && activeListingsCount > planActiveListings ? <br /> : null}
          {activeListingsCount > planActiveListings
            ? `You have ${activeListingsCount} live managed listings while your new plan allows only ${planActiveListings}`
            : null}
        </>
      }
      actions={
        <Button
          color="primary"
          onClick={() => {
            onClose();
            if (recommendedPlan) {
              onContinueToPlan(recommendedPlan.id);
            } else {
              onTalkToUs(activeListingsCount);
            }
          }}
        >
          {recommendedPlan ? `continue with the '${recommendedPlan.name}' plan` : "Let's talk"}
        </Button>
      }
      onClose={onClose}
      AlertProps={{icon: false, elevation: 0}}
    />
  );
};
export default WrongPlanDialog;
